/* Gestty — páginas de políticas: índice lateral, resumen y caja de ayuda. */
(function () {
  var cont = document.querySelector('.shopify-policy__container');
  if (!cont) return;
  var titulo = cont.querySelector('.shopify-policy__title');
  var cuerpo = cont.querySelector('.shopify-policy__body');
  if (!titulo || !cuerpo || cont.querySelector('.gt-pol__grid')) return;

  // Cabecera: antetítulo + subtítulo según la política
  var h1 = titulo.querySelector('h1');
  var ey = document.createElement('span');
  ey.className = 'gt-pol__eyebrow';
  ey.textContent = 'Información legal';
  titulo.insertBefore(ey, titulo.firstChild);
  var subs = {
    'reembolso': 'Cómo funcionan las devoluciones, los reembolsos y las garantías, también en los productos personalizados.',
    'envío': 'Plazos, costes y seguimiento de tu pedido.',
    'envio': 'Plazos, costes y seguimiento de tu pedido.',
    'privacidad': 'Qué datos tratamos, para qué y cómo puedes ejercer tus derechos.',
    'servicio': 'Las condiciones de compra de la tienda.'
  };
  var t = (h1 ? h1.textContent : '').toLowerCase();
  Object.keys(subs).forEach(function (k) {
    if (t.indexOf(k) !== -1 && !titulo.querySelector('.gt-pol__sub')) {
      var p = document.createElement('p');
      p.className = 'gt-pol__sub';
      p.textContent = subs[k];
      titulo.appendChild(p);
    }
  });

  // Índice con h2 (si hay ≥ 3) o con h3
  var h2 = cuerpo.querySelectorAll('h2'), h3 = cuerpo.querySelectorAll('h3');
  var cab = h2.length >= 3 ? h2 : (h3.length >= 3 ? h3 : []);
  var grid = document.createElement('div');
  grid.className = 'gt-pol__grid';
  cont.insertBefore(grid, cuerpo);
  if (cab.length) {
    var toc = document.createElement('details');
    toc.className = 'gt-pol__toc';
    toc.open = window.innerWidth >= 990;
    var sm = document.createElement('summary');
    sm.className = 'gt-pol__toc-titulo';
    sm.textContent = 'En esta página';
    toc.appendChild(sm);
    var ol = document.createElement('ol');
    Array.prototype.forEach.call(cab, function (h, i) {
      h.id = h.id || 'seccion-' + (i + 1);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.replace(/^\s*\d+\.\s*/, '');
      li.appendChild(a);
      ol.appendChild(li);
    });
    toc.appendChild(ol);
    grid.appendChild(toc);
    if ('IntersectionObserver' in window) {
      var enlaces = ol.querySelectorAll('a');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            enlaces.forEach(function (a) { a.removeAttribute('aria-current'); });
            var a = ol.querySelector('a[href="#' + e.target.id + '"]');
            if (a) a.setAttribute('aria-current', 'true');
          }
        });
      }, { rootMargin: '-15% 0px -75% 0px' });
      Array.prototype.forEach.call(cab, function (h) { io.observe(h); });
    }
  } else {
    grid.style.gridTemplateColumns = '1fr';
  }
  grid.appendChild(cuerpo);

  // Caja de ayuda al final
  var ayuda = document.createElement('div');
  ayuda.className = 'gt-pol__ayuda';
  ayuda.innerHTML = '<div><strong>¿Tienes alguna duda?</strong><span>Escríbenos y te respondemos en menos de 48 horas laborables.</span></div><a href="/pages/contact">Contactar</a>';
  cuerpo.appendChild(ayuda);
})();
